export default __webpack_public_path__ + "static/media/decline.942922e4.gif";